import type { ReactNode } from 'react';
import { errorMessage } from '../lib/errors';
import { Button } from './Button';
import styles from './States.module.css';

interface EmptyProps {
  art?: ReactNode;
  title: string;
  children?: ReactNode;
  actions?: ReactNode;
}

export function EmptyState({ art, title, children, actions }: EmptyProps) {
  return (
    <div className={styles.empty}>
      {art && <div className={styles.art}>{art}</div>}
      <h2 className={styles.title}>{title}</h2>
      {children && <div className={styles.text}>{children}</div>}
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}

export function Loading({ label = 'Loading' }: { label?: string }) {
  return (
    <div className={styles.loading} role="status">
      <span className="visually-hidden">{label}</span>
      <span className={styles.dot} />
      <span className={styles.dot} />
      <span className={styles.dot} />
    </div>
  );
}

export function ErrorNotice({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <div className={styles.error} role="alert">
      <p>{errorMessage(error)}</p>
      {onRetry && (
        <Button size="small" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
}
